import {useState} from "react";
import UnbxdCard from "../../../../../../components/SearchComponent/UnbxdComponents/UnbxdCard/UnbxdCard";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import ArrowSVG from "../../../../../../SVGObjects/UiKit/ArrowSVG";
import stl from "./LatestOffer.module.css";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import GrantedPopup from "../../../../../../components/SearchComponent/NewComponents/GrantedPopup/GrantedPopup";
import {useTranslation} from "@i18n";
import useHelpers from "@hooks/useHelpers";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
import {ModernCard} from "@/components/SearchComponent/ModernCard";

const LatestOffer = (
    {
        posts,
        lazyOnly,
        hasTitle,
        hasArrow
    }) => {
    const {t} = useTranslation();
    const {navigateTo} = useHelpers();
    const [showGrantedPopup, setShowGrantedPopup] = useState(false);
    return (
        <>
            <div className={stl.CLO_component}>
                {hasTitle && <h2>{t("آخر عروض السيارات", {ns: "web_city"})}</h2>}
                <div className={stl.CLO_postsContainer}>
                    {posts.length ? (
                        posts?.map((post, idx) => {
                            return (
                                <>
                                    <ModernCard
                                        key={post.id}
                                        post={post}
                                        showGrantedPopup={() => setShowGrantedPopup(true)}
                                        showGrantedLabel={true}
                                        rank={idx + 1}
                                    />
                                </>
                            )
                        })
                    ) : (
                        <BoxLoading divHeight={325} numberOfLoaders="8" hasCar/>
                    )}
                </div>
                <SubmitButton
                    className={`redBtn ${stl.customBtn} ${
                        hasArrow ? stl.customBtnFlex : ""
                    }`}
                    onClick={() => navigateTo("/filters")}
                    loading={false}
                >
                    {t("تصفح جميع السيارات", {ns: "web_city"})}
                    {hasArrow && (
                        <ArrowSVG
                            filledColor="white"
                            className={`m-show ${stl.rotateTheSVG}`}
                        />
                    )}
                </SubmitButton>
            </div>
            <BottomSheetPopup
                show={showGrantedPopup}
                onClose={() => setShowGrantedPopup(false)}
            >
                <GrantedPopup/>
            </BottomSheetPopup>
        </>
    );
};

export default LatestOffer;
